export default {
  setUser(state, user) {
    state.user = user;
  },
  setCertificateStatus(state, certificateStatus) {
    state.certificateStatus = certificateStatus;
  },
  updateUser(state, data) {
    for (const i in data) {
      state.user[i] = data[i];
    }
  },
  setLogged(state, logged) {
    state.logged = logged;
  },
  reset(state) {
    state.user = null;
    state.logged = false;
  },
  setNotifications(state, notifications) {
    state.notifications = notifications;
  },
  setCourseInfo(state, course_info) {
    state.course_info = course_info;
  }
};
